module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    staticClass: "pb-0 pr-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.isModalCambiosEnTicket),
      callback: function($$v) {
        _vm.isModalCambiosEnTicket = $$v
      },
      expression: "isModalCambiosEnTicket"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Cambios en el ticket")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Todos los procesos se aplicaran al numero de ticket")]), _c('div', {
    staticClass: "d-flex pa-3 fd-column"
  }, [_c('v-card', {
    staticClass: "flex-1 mb-3 pa-4",
    attrs: {
      "color": "background"
    }
  }, [_c('p', {
    staticClass: "mb-2 font-weight-700 primary--text"
  }, [_vm._v("Cambiar a un estado en especifico")]), _c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.estadosTicket,
      "item-value": "codigo",
      "item-text": "descripcion",
      "loading": _vm.isLoadingEstadosACambiar,
      "label": "Seleccionar estado",
      "dense": "",
      "solo": ""
    },
    model: {
      value: (_vm.estadoTicket),
      callback: function($$v) {
        _vm.estadoTicket = $$v
      },
      expression: "estadoTicket"
    }
  }), _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "block": "block",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchCambiarEstadoTicket()
      }
    }
  }, [_c('span', [_vm._v("Guardar cambios")])])], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-8"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "primary",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.closeDialogCambiosTicket()
      }
    }
  }, [_vm._v("regresar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "py-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    staticClass: "mr-4",
    attrs: {
      "label": "Numero",
      "dense": "dense",
      "hide-details": "hide-details",
      "solo": "solo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.resetLogsData(), _vm.fetchTickets()
      }
    },
    model: {
      value: (_vm.numeroTicket),
      callback: function($$v) {
        _vm.numeroTicket = $$v
      },
      expression: "numeroTicket"
    }
  }), _c('v-select', {
    staticClass: "mr-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "items": ['todos', 'garantia', 'incidencia con equipo', 'solicitud de insumo'],
      "label": "Tipo",
      "solo": "solo"
    },
    on: {
      "change": function($event) {
        _vm.resetLogsData(), _vm.fetchTickets()
      }
    },
    model: {
      value: (_vm.tipo),
      callback: function($$v) {
        _vm.tipo = $$v
      },
      expression: "tipo"
    }
  })], 1)]), _c('v-divider', {
    staticClass: "pa-0 ma-0"
  })], 1), _c('v-card', {
    staticClass: "box-logs",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-list', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "py-0",
    attrs: {
      "dense": "dense",
      "infinite-scroll-disabled": "disabledScrollExcecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('ticket-summary-info', {
      key: index,
      staticClass: "animated fadeInUp faster",
      attrs: {
        "ticket": o,
        "handler": true
      },
      on: {
        "href": function($event) {
          return _vm.fetchLogs(o.numero, index)
        }
      }
    })
  }), 1)], 1)], 1), _c('v-col', {
    staticClass: "pb-0 pr-0 pl-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "py-3"
  }, [_c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [(_vm.indexSeleccionado !== '') ? _c('span', {
    staticClass: "font-weight-700 font-size-21 primary--text"
  }, [_vm._v(" " + _vm._s(("#" + (_vm.lista[_vm.indexSeleccionado].numero))))]) : _vm._e(), _c('v-spacer'), _c('span', [_vm._v(" ")]), (_vm.indexSeleccionado !== '') ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "small",
      "color": "success",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogCambiosTicket()
      }
    }
  }, [_vm._v("realizar cambios")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    staticClass: "mr-4",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "items": _vm.accionesActividades,
      "label": "Buscar por accion",
      "solo": "solo"
    },
    on: {
      "change": _vm.filtrarPorAccion
    },
    model: {
      value: (_vm.accion),
      callback: function($$v) {
        _vm.accion = $$v
      },
      expression: "accion"
    }
  })], 1)], 1)]), _c('v-divider', {
    staticClass: "pa-0 ma-0"
  })], 1), _c('v-card', {
    staticClass: "box-logs elevation-1",
    class: {
      'jc-center ai-center d-flex': !_vm.logs.length
    },
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', [(_vm.logs.length) ? _c('div', [_c('div', {
    staticClass: "font-weight-bold ml-8 mb-2"
  }, [_vm._v("Hoy")]), _c('v-timeline', {
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((_vm.logs), function(a, index) {
    return _c('v-timeline-item', {
      key: index,
      staticClass: "pb-4",
      attrs: {
        "color": "primary",
        "small": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "font-weight-normal"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-12"
    }, [_vm._v(_vm._s(a.usuario) + "  ")]), _c('v-icon', {
      attrs: {
        "size": "13"
      }
    }, [_vm._v("access_time")]), _c('small', [_vm._v(" " + _vm._s(_vm._f("now")(a.fecha)) + " - " + _vm._s(_vm._f("formatDate")(a.fecha)))])], 1), (a.numeroActividad) ? _c('v-menu', {
      attrs: {
        "transition": "slide-y-transition",
        "bottom": "",
        "close-on-content-click": false
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "mr-3",
            attrs: {
              "x-small": "",
              "color": "info",
              "dark": ""
            },
            on: {
              "click": function($event) {
                return _vm.fetchActividad(a.numeroActividad)
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', {
            staticClass: "mr-1",
            attrs: {
              "size": "14"
            }
          }, [_vm._v("visibility")]), _vm._v("activ. (" + _vm._s(a.numeroActividad) + ")")], 1)]
        }
      }], null, true)
    }, [_c('span', [(_vm.isLoadingActividad) ? _c('v-progress-linear', {
      attrs: {
        "indeterminate": "indeterminate",
        "color": "primary"
      }
    }) : _c('item-actividad', {
      attrs: {
        "actividad": _vm.actividad,
        "is-log": "is-log"
      }
    })], 1)]) : _vm._e(), _c('span', {
      staticClass: "font-weight-700 info--text font-size-11"
    }, [_vm._v(_vm._s(a.accion))])], 1)])
  }), 1)], 1) : _c('div', {
    staticClass: "d-flex fd-column jc-center ai-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "background",
      "size": "100"
    }
  }, [_vm._v("clear_all")]), _c('span', {
    staticClass: "font-weight-700 primary--text"
  }, [_vm._v("No existen logs para mostrar")]), _c('span', {
    staticClass: "text-muted font-size-12"
  }, [_vm._v("Seleccione un ticket para obtener el listado de logs")])], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-750732a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_auditoria.vue
// module id = 511
// module chunks = 1